import { Honch } from './honch';
import type { HonchConfig, HonchInstance } from './config';

// Create singleton instance
const honchInstance = new Honch();

// Export the instance methods bound to the instance
const honch = {
    init: (token: string, options?: Partial<Omit<HonchConfig, 'token'>>) =>
        honchInstance.init(token, options),
    capture: (event: string, properties?: Record<string, unknown>) =>
        honchInstance.capture(event, properties),
    identify: (distinctId: string, properties?: Record<string, unknown>) =>
        honchInstance.identify(distinctId, properties),
    alias: (alias: string, distinctId?: string) =>
        honchInstance.alias(alias, distinctId),
    reset: () => honchInstance.reset(),
    setPersonProperties: (properties: Record<string, unknown>) =>
        honchInstance.setPersonProperties(properties),
    setPersonPropertiesOnce: (properties: Record<string, unknown>) =>
        honchInstance.setPersonPropertiesOnce(properties),
    register: (properties: Record<string, unknown>) =>
        honchInstance.register(properties),
    unregister: (key: string) => honchInstance.unregister(key),
    getDistinctId: () => honchInstance.getDistinctId(),
    getSessionId: () => honchInstance.getSessionId(),
    flush: () => honchInstance.flush(),
    opt_out: () => honchInstance.opt_out(),
    opt_in: () => honchInstance.opt_in(),
    isOptedOut: () => honchInstance.isOptedOut(),
    debug: (enabled?: boolean) => honchInstance.debug(enabled),
};

// Export for UMD (global `honch` object)
export default honch;

// Named exports for ESM/CJS
export { honch };
export type { HonchConfig, HonchInstance };

// Also attach to window for script tag usage
if (typeof window !== 'undefined') {
    (window as any).honch = honch;
}
